{
	"card": {
		"account": {
			"created": "Created on",
			"email": "Email",
			"name": "Name",
			"never": "Not verified",
			"status": "State",
			"verified": "Email verified on"
		},
		"applications": {
			"effective": "Counts from {{date}}",
			"empty": "No application sent.",
			"protocol": "Prot. {{protocol}}",
			"signed": "Sent on {{date}}"
		},
		"commands": {
			"code": "Send the sign-in code again",
			"code_description": "The student receives a new six-digit code at the address of the account, with the link to the sign-in page already prepared: it has to be opened in the browser they sign in from. The code they had before stops working. The limits of the sign-in page apply: one code a minute.",
			"code_done": "Code sent.",
			"code_title": "Send a new sign-in code?",
			"confirm": "Send",
			"no_applications": "The student has no signed application: there is no receipt to send.",
			"receipt": "Send the receipt again",
			"receipt_description": "The student receives a new email with the receipt of the signature and the up to date times.",
			"receipt_done": "Receipt sent.",
			"receipt_title": "Send the receipt again?"
		},
		"emails": {
			"empty": "No email.",
			"state": {
				"bounced": "Bounced",
				"complained": "Marked as spam",
				"delivered": "Delivered",
				"failed": "Not sent",
				"queued": "Queued",
				"sent": "Sent"
			},
			"template": {
				"receipt": "Receipt of the signature",
				"sign_code": "Signing code",
				"sign_in_code": "Sign-in code",
				"withdrawal_confirmed": "Withdrawal confirmed"
			}
		},
		"logged": "Opening this card is recorded in the access log. Uploaded documents are not shown here and no data can be changed.",
		"not_found": "Student not found",
		"requests": {
			"answer": "Answer: {{answer}}",
			"answer_label": "Answer given",
			"answer_required": "Write the answer given.",
			"close": "Close",
			"close_description": "Write the answer you gave the student.",
			"close_done": "Request closed.",
			"close_submit": "Close with the answer",
			"close_title": "Close the request",
			"closed": "Closed",
			"closed_at": "Closed on {{date}}",
			"empty": "No request.",
			"new": "Open a request",
			"new_description": "Write what the student asks. It stays open until you close it with the answer given.",
			"new_done": "Request opened.",
			"new_submit": "Open the request",
			"new_title": "Open a support request",
			"open": "Open",
			"opened": "Opened on {{date}}",
			"summary": "What the student asks",
			"summary_required": "Write what the student asks."
		},
		"sections": {
			"account": "Account",
			"applications": "Applications",
			"commands": "Sendings",
			"emails": "Latest emails",
			"requests": "Support requests"
		},
		"state": {
			"submitted": "Valid",
			"superseded": "Replaced",
			"withdrawn": "Withdrawn"
		},
		"status": {
			"active": "Active",
			"banned": "Blocked",
			"deleted": "Deleted"
		},
		"title": "Support card"
	},
	"page_title": "Support",
	"search": {
		"applications_one": "{{count}} application",
		"applications_other": "{{count}} applications",
		"hint": "Every search and every card opened is recorded in the access log with your name and the students seen. You do not need to write a reason.",
		"label": "Email, protocol or tax code",
		"no_name": "Name not given",
		"none": "No student found",
		"placeholder": "e.g. name@example.com, 12 or RSSMRA00A01H501Z",
		"results": "Results",
		"submit": "Search",
		"submit_again": "Search again",
		"too_many": "Too many results: type a longer email, a protocol or a full tax code."
	}
}
